module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showTemplate = true) && (_vm.template = {}) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Hinzufügen")], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Kategorie")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.templates), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          (_vm.showTemplate = true) && (_vm.template = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.kategorie))])])
  }), 0)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Template bearbeiten - " + _vm._s(_vm.template.name) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showTemplate = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Templatename"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "items": _vm.templateKategorien,
      "label": "Templatekategorie"
    },
    model: {
      value: (_vm.template.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.template, "kategorie", $$v)
      },
      expression: "template.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": "Inhalt",
      "rows": "25"
    },
    model: {
      value: (_vm.template.html),
      callback: function($$v) {
        _vm.$set(_vm.template, "html", $$v)
      },
      expression: "template.html"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": "700"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.template.html)
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteTemplate()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateTemplates()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c6d633"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Templates.vue
// module id = 743
// module chunks = 15